import actions from "./actions";

const initState = {
    userReadState: false,
    userUpdateState: false,
    userUpdateResult: {},
    userPasswordUpdateState: false,
    userPasswordUpdateResult: {},
    userLocaleUpdateState: false,
    user: {},
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.READ_USER_REQUEST:
            return {
                ...state,
                userReadState: 'request',
            };
        case actions.READ_USER_SUCCESS:
            return {
                ...state,
                userReadState: 'success',
                user: action.user,
            };
        case actions.UPDATE_USER_REQUEST:
            return {
                ...state,
                userUpdateState: 'request',
            };
        case actions.UPDATE_USER_SUCCESS:
            return {
                ...state,
                userUpdateState: 'success',
                userUpdateResult: action.user,
            };
        case actions.UPDATE_USER_PASSWORD_REQUEST:
            return {
                ...state,
                userPasswordUpdateState: 'request',
            };
        case actions.UPDATE_USER_PASSWORD_SUCCESS:
            return {
                ...state,
                userPasswordUpdateState: 'success',
                userPasswordUpdateResult: action.user,
            };
        case actions.UPDATE_USER_LOCALE_REQUEST:
            return {
                ...state,
                userLocaleUpdateState: 'request',
            };
        case actions.UPDATE_USER_LOCALE_SUCCESS:
            return {
                ...state,
                userLocaleUpdateState: 'success',
                user: action.user,
            };
        default:
            return state;
    }
}
